import React from "react";

export default function CardCompleted() {
  return <div>Completed</div>;
}
